import React, { useState, useEffect } from "react";
import PresasSinaloaNuevoDiseno from "./PresasSinaloaNuevoDiseno";
import PresasNayaritNuevoDiseno from "./PresasNayaritNuevoDiseno";
import DashPresaDetalle from "./DashPresaDetalle";

const VISTAS = ["Sinaloa", "Nayarit"];

export const DashPresasNuevoDiseno = ({ presassinaloa, presasnayarit, presassinaloamenos1, presasnayaritmenos1, presassinaloamenos2, presasnayaritmenos2 }) => {
    const [vistaIndex, setVistaIndex] = useState(0);
    const [presaSeleccionada, setPresaSeleccionada] = useState(null);
    const [presaHovered, setPresaHovered] = useState(null);

    // Limpiar selección y hover al cambiar de mapa
    useEffect(() => {
        setPresaSeleccionada(null);
        setPresaHovered(null);
    }, [vistaIndex]);

    if (!presassinaloa) return null;

    const irAnterior = () => setVistaIndex((prev) => (prev === 0 ? VISTAS.length - 1 : prev - 1));
    const irSiguiente = () => setVistaIndex((prev) => (prev === VISTAS.length - 1 ? 0 : prev + 1));

    // Año: extrae de total.fecha → presa.fecha → presa.fechaactualizacion (DD/MM/YYYY → YYYY)
    //      → cualquier presa del dataset que tenga fechaactualizacion
    const getAño = (dataset, presaObj) => {
        if (dataset?.total?.fecha) return String(dataset.total.fecha);
        if (presaObj?.fecha)       return String(presaObj.fecha);
        const fechaStr = presaObj?.fechaactualizacion
            || (dataset ? Object.values(dataset).find(v => v?.fechaactualizacion)?.fechaactualizacion : null);
        if (fechaStr) return fechaStr.slice(-4);   // "25/07/2024" → "2024"
        return null;
    };

    const presasActual  = vistaIndex === 0 ? presassinaloa       : presasnayarit;
    const presasMenos1  = vistaIndex === 0 ? presassinaloamenos1 : presasnayaritmenos1;
    const presasMenos2  = vistaIndex === 0 ? presassinaloamenos2 : presasnayaritmenos2;

    const presaData = presaSeleccionada ? presasActual?.[presaSeleccionada] : null;

    // Historial de la presa seleccionada (ascendente: 2024 → 2025 → 2026)
    const buildHistorial = (key) => [
        { año: getAño(presasMenos2, presasMenos2?.[key]), presa: presasMenos2?.[key] },
        { año: getAño(presasMenos1, presasMenos1?.[key]), presa: presasMenos1?.[key] },
        { año: getAño(presasActual,  presasActual?.[key]), presa: presasActual?.[key] },
    ].filter(h => h.presa)
     .sort((a, b) => parseInt(a.año) - parseInt(b.año));

    const historial = presaSeleccionada ? buildHistorial(presaSeleccionada) : [];

    // Historial del total (promedio general)
    const totalHistorial = [
        { año: getAño(presasMenos2, presasMenos2?.total), presa: presasMenos2?.total },
        { año: getAño(presasMenos1, presasMenos1?.total), presa: presasMenos1?.total },
        { año: getAño(presasActual,  presasActual?.total), presa: presasActual?.total },
    ].filter(h => h.presa)
     .sort((a, b) => parseInt(a.año) - parseInt(b.año));

    // Toggle: un segundo clic sobre la misma presa la deselecciona
    const handlePresaSelect = (key) =>
        setPresaSeleccionada((prev) => (prev === key ? null : key));
    const handlePresaHover = (key) => setPresaHovered(key);

    const mapaProps = {
        presaSeleccionada,
        presaHovered,
        onPresaSelect: handlePresaSelect,
        onPresaHover: handlePresaHover,
    };

    return (
        <div className="presas-card">
            {/* ── Header ─────────────────────────────────────────────────────── */}
            <div className="presas-header">
                <button className="presas-nav-btn" onClick={irAnterior}>‹</button>
                <div className="presas-title">
                    ALMACENAMIENTO DE PRESAS {VISTAS[vistaIndex].toUpperCase()}
                </div>
                <button className="presas-nav-btn" onClick={irSiguiente}>›</button>
            </div>

            {/* ── Cuerpo: mapa + detalle ──────────────────────────────────────── */}
            <div className="presas-container-main">

                {/* Mapa activo */}
                <div className="resumen-presas-container">
                    {vistaIndex === 0 && presassinaloa && (
                        <PresasSinaloaNuevoDiseno presas={presassinaloa} {...mapaProps} />
                    )}
                    {vistaIndex === 1 && presasnayarit && (
                        <PresasNayaritNuevoDiseno presas={presasnayarit} {...mapaProps} />
                    )}
                    <div
                        className={`presas-average-box${!presaSeleccionada ? ' presas-average-box--active' : ''}`}
                        onClick={() => setPresaSeleccionada(null)}
                        title="Ver promedio general"
                    >
                        <div className="presas-average-label">Promedio</div>
                        <div className="presas-average-value">
                            {presasActual?.total?.porcentaje ?? "—"}%
                        </div>
                    </div>
                </div>

                {/* Panel de detalle */}
                <div className="info-presas-detalle-container">
                    <DashPresaDetalle
                        presa={presaData}
                        presaKey={presaSeleccionada}
                        historial={historial}
                        totalPresa={presasActual?.total}
                        totalHistorial={totalHistorial}
                    />
                </div>
            </div>

            {/* ── Footer ─────────────────────────────────────────────────────── */}
            <div className="presas-footer">
                <span className="presas-footer-text">
                    Actualizado: {presasActual?.total?.fechaactualizacion ?? "—"}
                </span>
            </div>
        </div>
    );
};
